import apiClient from './client';
import type {
  GroupNote,
  DeletedGroupNote,
  CreateGroupNoteRequest,
  UpdateGroupNoteRequest,
  GroupNotesResponse,
  NoteType,
} from '../types/groupNote';

export const groupNotesApi = {
  /**
   * Создать заметку о группе
   */
  async create(groupId: string, data: CreateGroupNoteRequest): Promise<GroupNote> {
    const response = await apiClient.post<GroupNote>(
      `/groups/${groupId}/notes`,
      data
    );
    return response.data;
  },

  /**
   * Получить список заметок группы
   */
  async getByGroupId(
    groupId: string,
    params?: {
      limit?: number;
      offset?: number;
      type?: NoteType;
    }
  ): Promise<GroupNotesResponse> {
    const response = await apiClient.get<GroupNotesResponse>(
      `/groups/${groupId}/notes`,
      { params }
    );
    return response.data;
  },

  /**
   * Получить заметку по ID
   */
  async getById(groupId: string, noteId: string): Promise<GroupNote> {
    const response = await apiClient.get<GroupNote>(
      `/groups/${groupId}/notes/${noteId}`
    );
    return response.data;
  },

  /**
   * Обновить заметку
   */
  async update(
    groupId: string,
    noteId: string,
    data: UpdateGroupNoteRequest
  ): Promise<GroupNote> {
    const response = await apiClient.put<GroupNote>(
      `/groups/${groupId}/notes/${noteId}`,
      data
    );
    return response.data;
  },

  /**
   * Удалить заметку
   */
  async delete(groupId: string, noteId: string): Promise<void> {
    await apiClient.delete(`/groups/${groupId}/notes/${noteId}`);
  },

  /**
   * Корзина: удалённые за 30 дней, свежие первыми
   */
  async trash(groupId: string): Promise<DeletedGroupNote[]> {
    const response = await apiClient.get<{ notes: DeletedGroupNote[] | null }>(`/groups/${groupId}/notes/trash`);
    return response.data?.notes ?? [];
  },

  /**
   * Вернуть из корзины (повтор - та же запись)
   */
  async restore(groupId: string, noteId: string): Promise<GroupNote> {
    const response = await apiClient.post<GroupNote>(`/groups/${groupId}/notes/${noteId}/restore`);
    return response.data;
  },
};
